var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowLeftFillDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16974 8.34656L9.62196 11.8946C9.92921 12.1394 10.3957 11.9305 10.3957 11.548L10.3957 4.45198C10.3957 4.06951 9.92921 3.86057 9.62196 4.10542L5.16974 7.65344C4.94342 7.8338 4.94342 8.1662 5.16974 8.34656Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeftFillDark);
export default __webpack_public_path__ + "static/media/ic-arrow-left-fill-dark.e7c84f181cf44f4ef66ca134e59fe38c.svg";
export { ForwardRef as ReactComponent };